export default "/aweETH.7e55b757a56def82889ff814432842e6.png";